let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("wtjfs")).then(() => parcelRequire('8kJOj'));